<template>
  <v-card class="mx-auto" elevation="16" max-width="100hv">
    <v-card-item>
      <v-card-title> Home / Inicio </v-card-title>
      <v-card-subtitle>
        <div v-if="language == 'EN'">
          <h3>You are in the section to update only in English</h3>
          <h3>English</h3>
          <!-- <button @click="changeLanguage()" class="action-btn secondary-btn">
              <span class="language-tag">Change Language</span>
              {{ language == "EN" ? "ES" : "EN" }}
            </button> -->
        </div>

        <!-- <div v-else>
            <h2>Estas actualizando la sección en</h2>
            <h1>Español</h1>
            <button @click="changeLanguage()" class="action-btn secondary-btn">
              <span class="language-tag">Cambiar idioma</span>
              {{ language == "ES" ? "EN" : "ES" }}
            </button>
          </div> -->
      </v-card-subtitle>
    </v-card-item>
    <v-card-text>
      <v-row class="gap-y-6">
        <div class="home-page width100">
          <section class="video-background">
            <div class="bg-black"></div>

            <div id="video-poster" class="video-poster text-center">
              <video
                :src="require('@/assets/mina_video2.mp4')"
                poster="@/assets/video-cobre.jpeg"
                autoplay
                muted
                loop
                playsinline
              ></video>
            </div>
          </section>

          <div class="secondary-content">
            <section class="light-section">
              <div class="container">
                <div class="text-center">
                  <p
                    class=""
                    @dblclick="openEditModal('COBRE_HOME_01_' + language)"
                  >
                    <span
                      v-html="filterData('COBRE_HOME_01_' + language)"
                    ></span>
                  </p>
                </div>
              </div>
            </section>

            <section class="bg-iframe">
              <div class="about-info text-center">
                <section class="">
                  <iframe
                    class=""
                    width="660"
                    height="415"
                    src="https://www.youtube.com/embed/Eso5ZZPPATw"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen=""
                  >
                  </iframe>
                </section>
              </div>
            </section>

            <section class="gallery-section">
              <div class="about-info">
                <div>
                  <div class="custom-gallery-grid">
                    <!-- Imagen 1 -->
                    <div class="image image-1">
                      <img
                        :src="
                          searchImage('COBRE_HOME_1') !== null
                            ? searchImage('COBRE_HOME_1')
                            : `${BASEURL}/misc/img/site/gallery/img-gallery-01.jpg`
                        "
                        @dblclick="openEditImageModal('COBRE_HOME_1')"
                        @error="
                          (e) =>
                            (e.target.src = `${BASEURL}/misc/img/site/gallery/img-gallery-01.jpg`)
                        "
                        alt="Image 1"
                        loading="lazy"
                      />
                    </div>
                    <!-- Imagen 2 -->
                    <div class="image image-2">
                      <img
                        :src="
                          searchImage('COBRE_HOME_2') !== null
                            ? searchImage('COBRE_HOME_2')
                            : `${BASEURL}/misc/img/site/gallery/img-gallery-02.jpg`
                        "
                        @dblclick="openEditImageModal('COBRE_HOME_2')"
                        @error="
                          (e) =>
                            (e.target.src = `${BASEURL}/misc/img/site/gallery/img-gallery-02.jpg`)
                        "
                        alt="Image 2"
                        loading="lazy"
                      />
                    </div>
                    <!-- Imagen 3 -->
                    <div class="image image-3">
                      <img
                        :src="
                          searchImage('COBRE_HOME_3') !== null
                            ? searchImage('COBRE_HOME_3')
                            : `${BASEURL}/misc/img/site/gallery/img-gallery-03.jpg`
                        "
                        @dblclick="openEditImageModal('COBRE_HOME_3')"
                        @error="
                          (e) =>
                            (e.target.src = `${BASEURL}/misc/img/site/gallery/img-gallery-03.jpg`)
                        "
                        alt="Image 3"
                        loading="lazy"
                      />
                    </div>
                    <!-- Imagen 4 -->
                    <div class="image image-4">
                      <img
                        :src="
                          searchImage('COBRE_HOME_4') !== null
                            ? searchImage('COBRE_HOME_4')
                            : `${BASEURL}/misc/img/site/gallery/img-gallery-04.jpg`
                        "
                        @dblclick="openEditImageModal('COBRE_HOME_4')"
                        @error="
                          (e) =>
                            (e.target.src = `${BASEURL}/misc/img/site/gallery/img-gallery-04.jpg`)
                        "
                        alt="Image 4"
                        loading="lazy"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <!-- Modal Mejorado -->
            <div
              v-if="modalVisible"
              class="modal"
              @click="closeModal"
              @keydown.esc="closeModal"
              tabindex="0"
            >
              <div class="modal-content" @click.stop>
                <button class="modal-close" @click="closeModal">✕</button>
                <img :src="selectedImage" alt="Imagen grande" />

                <!-- Botones navegación -->
                <button class="nav-button prev" @click="prevImage">←</button>
                <button class="nav-button next" @click="nextImage">→</button>
              </div>
            </div>
          </div>
        </div>
      </v-row>
    </v-card-text>
  </v-card>
  <UpdateModal
    :visible="dialogVisible"
    :current-text="currentText"
    current-page="HOME-COBRE"
    :text-id="currentTextId"
    @update:visible="updateDialogVisible"
    @save-text="updateText"
  />
  <ModalUpdateImage
    :is-visible-image-u="dialogVisibleImage"
    :image-id="currentImageId"
    image-section="HOME-COBRE"
    @update:visible="updateDialogVisibleImage"
    @update:files="getImages"
  />
</template>

<script>
import { defineComponent, onMounted, ref } from "vue";
import {
  BASEURL,
  getLanguageForUpdateContent,
  setLanguageForUpdateContent,
} from "@/kernel/utils";
import { showInfoToast, showWarningToast } from "@/kernel/alerts";
import UpdateModal from "../../components/UpdateModal.vue";
import {
  getSectionByPageandlanguage,
  getImageBySection,
} from "../../services/sections-service";
import ModalUpdateImage from "../../components/ModalUpdateImage.vue";

export default defineComponent({
  name: "UpdateAboutEn",
  components: {
    UpdateModal,
    ModalUpdateImage,
  },
  setup() {
    const seeMore = async () => {
      showWarningToast("Not active");
    };

    const images = [
      `${BASEURL}/misc/img/site/gallery/img-gallery-01.jpg`,
      `${BASEURL}/misc/img/site/gallery/img-gallery-02.jpg`,
      `${BASEURL}/misc/img/site/gallery/img-gallery-03.jpg`,
      `${BASEURL}/misc/img/site/gallery/img-gallery-04.jpg`,
    ];

    const selectedImage = ref(null);
    const modalVisible = ref(false);
    const currentIndex = ref(0);

    const openModal = (src) => {
      currentIndex.value = images.indexOf(src);
      selectedImage.value = src;
      modalVisible.value = true;

      // Para activar eventos del teclado (como ESC)
      setTimeout(() => {
        document.querySelector(".modal")?.focus();
      }, 50);
    };

    const closeModal = () => {
      modalVisible.value = false;
    };

    const nextImage = () => {
      currentIndex.value = (currentIndex.value + 1) % images.length;
      selectedImage.value = images[currentIndex.value];
    };

    const prevImage = () => {
      currentIndex.value =
        (currentIndex.value - 1 + images.length) % images.length;
      selectedImage.value = images[currentIndex.value];
    };

    const seeMoreEsg = async () => {
      showWarningToast("Not active");
    };

    const seeMoreGallery = async () => {
      showWarningToast("Not active");
    };

    const dataHome = ref([
      {
        section_id: "COBRE_HOME_01_EN",
        description:
          "For more information, visit our parent company’s website,<br /> Frontera Copper Corporation",
      },
      {
        section_id: "COBRE_HOME_01_ES",
        description:
          "For more information, visit our parent company’s website,<br /> Frontera Copper Corporation",
      },
    ]);

    const fetchData = async () => {
      try {
        const dataForm = {
          page: "HOME-COBRE",
          language: getLanguageForUpdateContent(),
        };
        const response = await getSectionByPageandlanguage(dataForm);
        if (response.status === 200) {
          if (parseInt(response.data.length) !== 0) {
            dataHome.value = response.data;
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const filterData = (found_id) => {
      const filteredData = dataHome.value.filter(
        (item) => item.section_id === found_id
      );
      return filteredData.length > 0 ? filteredData[0].description : null;
    };

    const changeLanguage = () => {
      const lang = getLanguageForUpdateContent() === "EN" ? "ES" : "EN";
      setLanguageForUpdateContent(lang);
      showInfoToast(
        `Language changed to ${lang === "EN" ? "English" : "Spanish"}`
      );
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    };

    const dialogVisible = ref(false);
    const currentText = ref("");
    const currentTextId = ref("");

    const updateDialogVisible = (visible) => {
      dialogVisible.value = visible;
    };

    const updateText = ({ id, text }) => {
      const index = dataHome.value.findIndex((item) => item.section_id === id);
      if (index !== -1) {
        dataHome.value[index].description = text;
      }
    };

    const openEditModal = (textId) => {
      showInfoToast(`Double click to edit the text: ${textId}`);
      const textToEdit = filterData(textId);
      currentText.value = textToEdit;
      currentTextId.value = textId;
      dialogVisible.value = true;
    };

    const imagesHome = ref([]);

    const dialogVisibleImage = ref(false);
    const currentImageId = ref("");

    const updateDialogVisibleImage = (visible) => {
      dialogVisibleImage.value = visible;
    };

    const openEditImageModal = (imageId) => {
      showInfoToast(`Double click to edit the image: ${imageId}`);
      currentImageId.value = imageId;
      dialogVisibleImage.value = true;
    };

    const searchImage = (imageId) => {
      const foundImage = imagesHome.value.find(
        (image) => image.image_id === imageId
      );
      return foundImage ? BASEURL + foundImage.image_path : null;
    };

    const getImages = async () => {
      try {
        const dataForm = {
          page: "HOME-COBRE",
        };
        const result = await getImageBySection(dataForm);
        if (result.status === 200) {
          if (result.data.content !== null) {
            imagesHome.value = result.data.content;
          }
        }
      } catch (error) {
        console.log("Error fetching images:", error);
      }
    };

    onMounted(() => {
      fetchData();
      getImages();
    });

    return {
      BASEURL,
      language: getLanguageForUpdateContent(),
      changeLanguage,
      filterData,
      openEditModal,
      updateDialogVisible,
      updateText,
      dialogVisible,
      currentText,
      currentTextId,
      selectedImage,
      modalVisible,
      openModal,
      closeModal,
      nextImage,
      prevImage,
      seeMore,
      seeMoreEsg,
      seeMoreGallery,
      searchImage,
      updateDialogVisibleImage,
      openEditImageModal,
      dialogVisibleImage,
      currentImageId,
      getImages,
    };
  },
});
</script>

<style scoped>
.bg-black {
  position: relative;
  width: 100%;
  height: 140px;
  background-color: #000;
  z-index: -1 !important;
}

.video-background {
  position: relative;
  height: 80vh;
  min-width: 50vw;
  overflow: hidden;
  background-color: #d32a28;
  z-index: -1 !important;
}

.vimeo-wrapper {
  position: relative;
  z-index: 6;
  margin-top: -120px;
  height: 80vh;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.video-poster {
  position: absolute;
  margin-top: -120px;
  width: 98%;
  height: 80vh;
  z-index: 5;
  left: 1%;
  transition: opacity 0.5s erase;
}

.video-poster.hidden {
  opacity: 0;
  pointer-events: none;
}

.video-poster video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  object-position: center;
}

.video-background iframe {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  transform: translate(-50%, -50%);
}

.secondary-content {
  background-color: #e4e5e5;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.bg-iframe {
  background-color: black;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

@media screen and (max-width: 768px) {
  .bg-iframe {
    padding: 32px 16px 32px 16px;
  }

  .embed-responsive-item {
    width: 100%;
    height: 100%;
  }
}

.light-section,
.iframe-section,
.gallery-wrapper {
  background-color: #e4e5e5;
  padding: 24px;
}

.gallery-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f05a29;
}

.gallery-section {
  width: 100%;
  background-color: #f05a29;
}

.text-center {
  text-align: center;
}

.large-text {
  font-size: 1.5rem;
  margin-bottom: 16px;
}

.btn {
  display: inline-block;
  padding: 10px 20px;
  border-radius: 5px;
  text-decoration: none;
  color: #fff;
  background-color: #df510f;
  transition: background-color 0.3s;
}

.primary-btn:hover {
  background-color: #893e01;
}

.responsive-embed {
  position: relative;
  width: 100%;
  padding-top: 56.25%;
}

.responsive-embed iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.custom-gallery-grid {
  display: grid;
  grid-template-areas:
    "img1 img2 img3"
    "img4 img4 img4";
  grid-template-columns: repeat(3, auto);
  gap: 8px;
  /* Compacto en pantallas grandes */
  justify-content: center;
  align-items: start;
  max-width: 1000px;
  margin: 0 auto;
}

/* Imágenes cuadradas (1, 2 y 3) */
.image {
  width: 200px;
  height: 200px;
  overflow: hidden;
  border-radius: 12px;
}

.image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.image img:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
}

/* Imagen 4: tamaño original */
.image-4 {
  grid-area: img4;
  grid-column: span 3;
  width: auto;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-4 img {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 12px;
}

/* Responsive */
@media (max-width: 768px) {
  .custom-gallery-grid {
    grid-template-areas:
      "img1"
      "img2"
      "img3"
      "img4";
    grid-template-columns: 1fr;
    justify-items: center;
    /* centrar las imágenes */
  }

  .image {
    max-width: 100px;
    max-height: 100px;
  }

  .image img {
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
  }

  .image-4 {
    max-width: 100%;
    /* Asegúrate de que ocupe el máximo espacio */
  }

  .image-4 img {
    width: 100%;
    height: auto;
    object-fit: contain;
  }
}

/* Estilos para el Modal */
.modal {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.85);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  outline: none;
}

.modal-content {
  position: relative;
  max-width: 90%;
  max-height: 90%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 0 20px rgba(255, 255, 255, 0.15);
}

.modal-close {
  position: absolute;
  top: -12px;
  right: -12px;
  background: #fff;
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.nav-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.85);
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  user-select: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.nav-button.prev {
  left: -50px;
}

.nav-button.next {
  right: -50px;
}

@media (max-width: 768px) {
  .nav-button.prev {
    left: 10px;
  }

  .nav-button.next {
    right: 10px;
  }
}

/* Estilos de la tarjeta */
.language-tag {
  font-size: 0.75rem;
  background: rgba(255, 255, 255, 0.2);
  padding: 2px 6px;
  border-radius: 4px;
}

.action-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.secondary-btn {
  background: #f59e0b;
  color: white;
}

.secondary-btn:hover {
  background: #d97706;
  box-shadow: 0 4px 6px rgba(245, 158, 11, 0.3);
}
</style>
